// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "*{margin:0;padding:0}body.ffa-app{--brand-color-light:#3c55ae;--brand-color-dark:#1a2a6c}body.ocean-app{--brand-color-light:#0e664a;--brand-color-dark:#053d28}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
